export function tenantKey() {
  return process.env.VUE_APP_TENANT_KEY ?? "RSA";
}

export function filterTenantDisplay(array: Array<any>) {
  return array.filter(x => {
    if (!x.tenantExclude) {
      return true;
    }

    return !x.tenantExclude.includes(tenantKey());
  });
}